import React from "react";
import { Field, ErrorMessage } from "formik";
import {
  PhoneInput,
  parseCountry,
  defaultCountries,
} from "react-international-phone";

import ErrorTextMessage from "../errorTextMessage/ErrorTextMessage";
import { EMPTY_STRING } from "../../../constants";
import { COUNTRY_CODE_ENUMS } from "../../../system/globalEnums";

//-------countries a store or company can be in, customers can have a phone number of any country
const supportedCountries = defaultCountries.filter((country) =>
  Object.values(COUNTRY_CODE_ENUMS).includes(
    parseCountry(country).iso2.toUpperCase()
  )
);

//-------PhoneInputField component start here
const PhoneInputField = (props) => {
  const {
    name,
    label,
    defaultCountry,
    className = EMPTY_STRING,
    isSupportedCountriesOnly = false,
    countries = [],
  } = props;

  //-------dial code alone is an empty phone number
  const getPhoneValue = (phone, country) => {
    return phone === `+${country.dialCode}` ? EMPTY_STRING : phone;
  };

  //-------Return PhoneInputField Component
  return (
    <div>
      {label && (
        <label className="field-label" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="input-field-wrapper">
        <Field name={name}>
          {({ field, form }) => (
            <PhoneInput
              key={defaultCountry}
              name={name}
              value={field.value}
              defaultCountry={defaultCountry?.toLowerCase()}
              countries={
                countries.length > 0
                  ? defaultCountries.filter((country) =>
                      countries.includes(
                        parseCountry(country).iso2.toUpperCase()
                      )
                    )
                  : isSupportedCountriesOnly
                  ? supportedCountries
                  : defaultCountries
              }
              className={`input-textfield phone-input-field ${className}`}
              inputProps={{ id: name }}
              onBlur={field.onBlur}
              onChange={(phone, { country }) =>
                form.setFieldValue(name, getPhoneValue(phone, country))
              }
            />
          )}
        </Field>
      </div>
      <ErrorMessage name={name} component={ErrorTextMessage} />
    </div>
  ); //-------PhoneInputField component end here
};

//-------Export PhoneInputField Component
export default PhoneInputField;
